import { render, staticRenderFns } from "./Geet.vue?vue&type=template&id=99c90c9a&scoped=true"
import script from "./Geet.vue?vue&type=script&lang=js"
export * from "./Geet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c90c9a",
  null
  
)

export default component.exports